import { render, staticRenderFns } from "./Tables.vue?vue&type=template&id=2fe51090&scoped=true&"
import script from "./Tables.vue?vue&type=script&lang=js&"
export * from "./Tables.vue?vue&type=script&lang=js&"
import style0 from "./Tables.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Tables.vue?vue&type=style&index=1&id=2fe51090&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe51090",
  null
  
)

export default component.exports